<template>
    <div class="popup">
        <van-popup
            v-model="show"
            position="bottom"
            :close-on-click-overlay='false'
        >
            <div class="bottom">
                <div class="content">
                    <div class="title borderBot borderBotLeft0">
                        <h3>为了方便使用，请前去认证</h3>
                        <p>企业级别的用户拥有专享服务，优惠更多，返利更多</p>
                    </div>
                    <div class="li borderBot borderBotLeft0" @click="goBusinessOpen(12)">
                        我是企业
                    </div>
                    <!-- <div class="li borderBot borderBotLeft0" @click="goBusinessOpen(13)">
                        我是个体工商户
                    </div> -->
                    <div class="li" @click="goBusinessOpen(11)">
                        我是个人
                    </div>
                </div>
                <div class="btn" @click="onHide">
                    取消
                </div>
            </div>
        </van-popup>
    </div>
</template>
<script>
export default {
    name: 'popup',
    props: {
        openStatus: {
            type: Number,
            default: 1
        }
    },
    data () {
        return {
            show: false
        }
    },
    methods: {
        onShow () {
            this.show = true
        },
        onHide () {
            this.show = false
        },
        goBusinessOpen (userType) {
            localStorage.removeItem('openAccountInfo')
            this.$router.push(
                {
                    path: '/b2b/business/open',
                    query: { userType, type: this.openStatus === 1 }
                }
            )
        }
    }
}
</script>
<style lang="scss" scoped>
.bottom{
    margin: 0 24px;
    text-align: center;
    font-size: 36px;
    color: #000000;
    .content {
        background: #ffffff;
        border-radius: 8px;
        .title {
            font-size: 32px;
            color: #666666;
            padding: 32px 0;
            position: relative;
            p{
                font-size: 24px;
                color: #999999;
                margin-top: 8px;
            }
        }
        .li{
            padding: 32px 0;
            position: relative;
        }
    }
    .btn{
        background: #ffffff;
        border-radius: 8px;
        padding: 32px 0;
        margin: 12px 0;
        color: #FF7A45;
    }
}
/deep/ .van-popup{
    background: none
}
</style>